__webpack_require__.O(0, ["article_content"], () => {
	["node_modules_swiper_modules_pagination_css","resources_src_js_share_components__common_lazy_js","resources_src_js_share_components__font_family_js"].map(__webpack_require__.E);
}, 5);